'use strict';

import React from 'react';
import { useEffect, useState, useContext, useRef } from 'react';

import { Table, Button, Form, Col, Row, Stack, OverlayTrigger, Tooltip, Popover, Tabs, Tab } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import useRequest from '../helper/useRequest';
import { formatDate, formatTime } from '../helper/DateTimeFormater';
import { toast } from 'react-toastify';
import useConfirmation from '../helper/Confirmation';
import AppContext from '../AppContext';
import Loader from '../helper/Loader';
import { customFilterFunction } from '../helper/CustomFilter';
import TableHeader from '../helper/TableHeader';

import Alert from '../helper/Alert';
import ModalDefault from '../helper/Modal/Modal';
import CustomFilter from '../helper/CustomFilter';

import Select from 'react-select';

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    useReactTable,
} from '@tanstack/react-table'

import { date, timeStart, timeEnd, grade, nameClass } from '../helper/Schema';

const columnHelper = createColumnHelper();

function validateTimes(start, end, minDiff) {
    let s = {};
    let e = {};
    if (start.length) { s = new Date("1970-01-01 " + start); }
    else return false;
    if (end.length) { e = new Date("1970-01-01 " + end); }
    else return false;

    let diff = e.getTime() - s.getTime();
    let check = 60000 * minDiff;
    return diff >= check;
}

const EditTimeslot = ({ timeslot, open, setOpen, editTimeslot }) => {
    const { request } = useRequest();
    const [message, setMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const [equipment, setEquipment] = useState([]);
    const [categories, setCategories] = useState([]);
    const [contactPersons, setContactPersons] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const formRef = useRef();
    const footer = <Button disabled={loading} variant="secondary" onClick={() => formRef.current.submitForm()}>Speichern</Button>;

    const schema = {
        appointment: date.test("checkDate", "Es kann kein Termin an einem Sonntag stattfinden.", (value) => { return value.getDay() > 0; },),
        timeStart: timeStart,
        timeEnd: timeEnd.test("checkEndTime", "Die Endzeit muss mindestens 30 Minuten nach der Startzeit liegen.", (value) => { return validateTimes(formRef.current.values.timeStart, value, 30); }),
        grade: grade,
        nameClass: nameClass
    }

    const setOpen2 = (s) => {
        if (loading) return;

        setOpen(s);
    }

    const updateTimeslot = async (values) => {
        let data = {
            TimeslotID: timeslot.TimeslotID,
            Date: values.appointment,
            TimeStart: values.timeStart,
            TimeEnd: values.timeEnd,
            Grade: values.grade,
            Class: values.nameClass,
            Room: null,
            ExpireTime: values.expiration,
            Equipment: values.equipment.map(({ value }) => (parseInt(value))),
            Categories: values.categories.map(({ value }) => (parseInt(value))),
            ContactPersonSchool: values.contactPerson.value,
            CriminalRecord: values.criminalRecord,
        };

        if (values.room) {
            data.Room = values.roomName;
        }

        try {
            if (data.Expiration < 0) {
                toast.error("Die eingegebene Ablaufzeit (in Stunden vor Termin-Begin) ist negativ. Bitte ändern Sie Ihre Eingabe auf eine positive Ganzzahl.");
            }
            else {
                setMessage(false);
                setLoading(true);
                let result = await request("/School/EditTimeslot", data);
                setLoading(false);
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        setMessage(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                    }
                }
                else {
                    toast.success("Termin erfolgreich gespeichert.");
                    editTimeslot(json.timeslot);
                    setOpen(false);
                }
            }
        }
        catch {
            setLoading(false);
            toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
        }
    }

    useEffect(() => {
        if (!formRef.current) return;

        if (timeslot.Status != 1) {
            setDisabled(true);
        }
        else {
            setDisabled(false);
        }

        formRef.current.setFieldValue("appointment", timeslot.Appointment);
        formRef.current.setFieldValue("timeStart", timeslot.TimeStart.substr(0, 5));
        formRef.current.setFieldValue("timeEnd", timeslot.TimeEnd.substr(0, 5));
        formRef.current.setFieldValue("grade", timeslot.Grade);
        formRef.current.setFieldValue("nameClass", timeslot.Class);
        if (timeslot.Room) {
            formRef.current.setFieldValue("room", true);
            formRef.current.setFieldValue("roomName", timeslot.Room);
        }
        else {
            formRef.current.setFieldValue("room", false);
        }
         
        formRef.current.setFieldValue("equipment", timeslot.Equipment.map((val) => { return { value: val.EquipmentID, label: val.Description } }));
        formRef.current.setFieldValue("categories", timeslot.Category.map((val) => { return { value: val.CategoryID, label: val.Description } }));
        formRef.current.setFieldValue("expiration", timeslot.ExpireTime);
        formRef.current.setFieldValue("contactPerson", { value: timeslot.ContactSchool.ContactPersonID, label: timeslot.ContactSchool.FirstName + " " + timeslot.ContactSchool.LastName });

        if (timeslot.CriminalRecord) {
            formRef.current.setFieldValue("criminalRecord", true);
        }
    }, [timeslot]);

    useEffect(() => {
        const getSettings = async () => {
            try {
                let result = await request("/User/GetOrganisationSettings");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        aler.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut");
                    }
                }
                else {
                    let defaultPerson = false;
                    let persons = json.contactPerson.map((val) => {
                        if (val.DefaultPerson == 1) {
                            defaultPerson = val;
                            return { value: 0, label: val.FirstName + " " + val.LastName }
                        }
                        return { value: val.ContactPersonID, label: val.FirstName + " " + val.LastName }
                    });


                    setEquipment(json.equipment.map((val) => { return { value: val.EquipmentID, label: val.Description } }));
                    setCategories(json.categories.map((val) => { return { value: val.CategoryID, label: val.Description } }));
                    setContactPersons(persons);

                }
            }
            catch (e) {
                toast.error("Fehler beim Laden.");
            }
        }
        getSettings();
    }, []);   

    return (
        <ModalDefault open={open} setOpen={setOpen2} title="Termin bearbeiten" footer={footer}>
            {message && <Alert type="error" message={message} />}

            <Formik
                innerRef={(f) => { formRef.current = f; }}
                validationSchema={yup.object().shape(schema)}
                onSubmit={(values) => {
                    updateTimeslot(values);
                }}
                initialValues={{
                    appointment: '',
                    timeStart: '',
                    timeEnd: '',
                    grade: 5,
                    nameClass: '',
                    room: false,
                    roomName: '',
                    equipment: [],
                    categories: [],
                    expiration: 24,
                    contactPerson: '',
                    criminalRecord: false
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => {

                    return (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Stack gap={2}>
                                <Form.Group className="form-group" controlId="appointment">
                                    <Form.Label>Datum</Form.Label>
                                    <Form.Control disabled={disabled || loading} isInvalid={errors.appointment && touched.appointment} type="date" placeholder="" name="appointment" value={values.appointment} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.appointment}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Row className="form-group">
                                    <Col>
                                        <Form.Group controlId="timeStart">
                                            <Form.Label>Anfangszeit</Form.Label>
                                            <Form.Control disabled={disabled || loading} isInvalid={errors.timeStart && touched.timeStart} type="time" placeholder="" name="timeStart" value={values.timeStart} onBlur={handleBlur} onChange={(e) => { handleChange(e); }} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.timeStart}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group controlId="timeEnd">
                                            <Form.Label>Endzeit</Form.Label>
                                            <Form.Control disabled={disabled || loading} isInvalid={errors.timeEnd && touched.timeEnd} type="time" placeholder="" name="timeEnd" value={values.timeEnd} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.timeEnd}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="form-group">
                                    <Col>
                                        <Form.Group controlId="grade">
                                            <Form.Label>Stufe</Form.Label>
                                            <Form.Control disabled={loading} isInvalid={errors.grade && touched.grade} type="number" step="1" min="5" max="13" placeholder="" name="grade" value={values.grade} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.grade}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group controlId="nameClass">
                                            <Form.Label>Klassenbezeichnung</Form.Label>
                                            <Form.Control disabled={loading} isInvalid={errors.nameClass && touched.nameClass} type="text" placeholder="" name="nameClass" value={values.nameClass} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.nameClass}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="form-group" controlId="room">
                                    <Form.Check disabled={loading} type="checkbox" label="Raumbezeichnung" checked={values.room} value={values.room} onChange={handleChange} />
                                </Form.Group>

                                {values.room && (
                                    <Form.Group className="form-group" controlId="roomName">
                                        <Form.Label>Raumbezeichnung</Form.Label>
                                        <Form.Control disabled={loading} isInvalid={errors.roomName && touched.roomName} type="text" placeholder="" name="roomName" value={values.roomName} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.roomName}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                )}



                                <Form.Group className="form-group" controlId="equipment">
                                    <Form.Label>Ausstattung</Form.Label>
                                    <Select isDisabled={loading} isMulti closeMenuOnSelect={false} name="Equipment" options={equipment} value={values.equipment} classname="basic-multi-select" placeholder="Bitte ausw&auml;hlen" onChange={
                                        (values) => {
                                            formRef.current.setFieldValue("equipment", values);
                                        }
                                    } />
                                </Form.Group>

                                <Form.Group className="form-group" controlId="categories">
                                    <Form.Label>NICHT erw&uuml;nschte Betriebskategorien</Form.Label>
                                    <Select isDisabled={disabled} isMulti closeMenuOnSelect={false} name="Categories" options={categories} value={values.categories} classname="basic-multi-select" placeholder="Bitte ausw&auml;hlen" onChange={
                                        (values) => {
                                            formRef.current.setFieldValue("categories", values);
                                        }
                                    } />
                                </Form.Group>

                                <Form.Group className="form-group" controlId="expiration">
                                    <Form.Label>Ablaufzeit (in Stunden vor Termin-Begin)</Form.Label>
                                    <Form.Control disabled={disabled || loading} isInvalid={errors.expiration && touched.expiration} type="number" step="1" value={values.expiration} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.expiration}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="form-group" controlId="contactPerson">
                                    <Form.Label>Kontaktperson</Form.Label>
                                    <Select isDisabled={loading} name="contactPerson" options={contactPersons} value={values.contactPerson} classname="basic-select" onChange={
                                        (values) => {
                                            formRef.current.setFieldValue("contactPerson", values);
                                        }
                                    } />
                                </Form.Group>

                                {/*<Form.Group className="form-group" controlId="criminalRecord">
                                    <Form.Check disabled={disabled || loading} type="checkbox" label="Erweitertes Führungszeugnis muss vorliegen" checked={values.criminalRecord} value={values.criminalRecord} onChange={handleChange} />
                                </Form.Group>*/}
                            </Stack>
                        </Form>
                    )
                }}
            </Formik>
        </ModalDefault>
    );
};

function Timeslots() {
    const { request } = useRequest();
    const context = useConfirmation();
    const { getSalutation } = useContext(AppContext);

    const [realTimeslots, setRealTimeslots] = useState(false);
    const [timeslots, setTimeslots] = useState(false);
    const [realTimeslotsPast, setRealTimeslotsPast] = useState(false);
    const [timeslotsPast, setTimeslotsPast] = useState(false);
    const [key, setKey] = useState('now');
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);
    const [statusFilter, setStatusFilter] = useState({ value: 0, label: "alle" });
    const [periodFilter, setPeriodFilter] = useState({ value: 1, label: "aktuelle" });
    const [year, setYear] = useState({ label: new Date().getFullYear(), value: new Date().getFullYear() });
    const [years, setYears] = useState([]);

    const [timeslot, setTimeslot] = useState(false);
    const [open, setOpen] = useState(false);

    const getBusinessContact = (booked, contact, sndContact) => {
        if (!booked) return "";
        return sndContact.SalutationID != '0' ? (
            <>
                <div><a href={"/School/Business/" + booked.OrganisationID}>{booked.OrganisationName}, {booked.Street} {booked.HouseNo} {booked.PostCode} {booked.City}</a></div>
                <div>{(contact.SalutationID == 3) ? "---" : getSalutation(contact.SalutationID)} {contact.Title} {contact.FirstName} {contact.LastName} ({contact.Email})</div>
                <div>{(sndContact.SalutationID == 3) ? "---" : getSalutation(sndContact.SalutationID)} {sndContact.Title} {sndContact.FirstName} {sndContact.LastName} ({sndContact.Email})</div> 
            </>
        ) : (
            <>
                <div><a href={"/School/Business/" + booked.OrganisationID}>{booked.OrganisationName}, {booked.Street} {booked.HouseNo} {booked.PostCode} {booked.City}</a></div>
                <div>{(contact.SalutationID == 3) ? "---" : getSalutation(contact.SalutationID)} {contact.Title} {contact.FirstName} {contact.LastName} ({contact.Email})</div>
            </>
        );
    }

    const selectTimeslot = async (timeslot) => {
        setOpen(true);
        setTimeslot({ ...realTimeslots.find(m => m.TimeslotID == timeslot.TimeslotID) });
    }

    const deleteTimeslot = async (id) => {
        try {
            let result = await request("/School/DeleteTimeslot", { timeslotID: id });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Zeitsatz gelöscht.");
                updateTimeslots(id);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    };

    const getAddTimeslotUrl = (slot) => {
        const timeslot = realTimeslots.find(m => m.TimeslotID == slot.TimeslotID);
        let url = "?d=" + timeslot.Appointment;
        url += "&ts=" + timeslot.TimeStart.substr(0, 5);
        url += "&te=" + timeslot.TimeEnd.substr(0, 5);
        url += "&g=" + timeslot.Grade;
        url += "&c=" + timeslot.Class;
        url += "&e=" + timeslot.Equipment.map(item => item.EquipmentID).join(",");
        url += "&ca=" + timeslot.Category.map(item => item.CategoryID).join(",");
        url += "&ex=" + timeslot.ExpireTime;
        url += "&co=" + timeslot.ContactPersonSchool;

        if (timeslot.CriminalRecord) {
            url += "&cr=1";
        }

        if (timeslot.Room) {
            url += "&r=" + timeslot.Room;
        }

        return url;
    }

    const columns = [
        columnHelper.accessor('StatusString', {
            header: () => (
                <OverlayTrigger popperConfig={{
                    modifiers: {
                        name: "offset",
                        options: {
                            offset: [0, 20]
                        }
                    }
                }} placement="left" overlay={(
                    <Popover id="slot-status-info">
                        <Popover.Header as="h3">Status</Popover.Header>
                        <Popover.Body>
                            <div><span className="bookedCircle me-2"></span>offen</div>
                            <div><span className="bookedCircle booked me-2"></span>gebucht</div>
                            <div><span className="bookedCircle canceled me-2"></span>storniert</div>
                        </Popover.Body>
                    </Popover>
                )}>
                    <span>Status</span>
                </OverlayTrigger>
            ),
            cell: info => {
                let statusCircle = <span className="bookedCircle"></span>;
                if (info.getValue() == "gebucht") {
                    statusCircle = <span className="bookedCircle booked"></span>;
                }
                else if (info.getValue() == "storniert") {
                    statusCircle = <span className="bookedCircle canceled"></span>;
                }

                return (
                    <OverlayTrigger placement="left" overlay={<Tooltip>{info.getValue()}</Tooltip>}>
                        <>{statusCircle} {info.getValue()}</>
                    </OverlayTrigger>
                );
            },
            enableColumnFilter: true,
            filterFn: customFilterFunction,
            meta: {
                filterComponent: "select",
            }
        }),
        columnHelper.accessor('Appointment', {
            header: () => <span>Datum</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeStart', {
            header: () => <span>Startzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeEnd', {
            header: () => <span>Endzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Grade', {
            header: () => <span>Stufe</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Class', {
            header: () => <span>Klasse</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Room', {
            header: () => <span>Raum</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Equipment', {
            header: () => <span>Ausstattung</span>,
            cell: info => info.getValue(),
            enableSorting: false,
            enableColumnFilter: true,
        }),
        columnHelper.accessor('BookedBusiness', {
            header: () => <span>Buchende Organisation</span>,
            cell: info => {
                return getBusinessContact(info.row.original.BookedOrganisation, info.row.original.ContactOrganisation, info.row.original.SndContactOrganisation);
            },
            enableSorting: false,
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeslotID', {
            size: 180,
            header: () => <span></span>,
            cell: info => {
                if (new Date(info.row.original.Appointment) < new Date()) return;

                let delBtn;
                delBtn = (
                    <OverlayTrigger overlay={<Tooltip>Löschen</Tooltip>}>
                        <Button variant="danger" size="sm" onClick={() => context.openModal("Wirklich löschen?", "Möchten Sie diesesn Termin wirklich löschen?", () => { deleteTimeslot(info.getValue()) }, "Ja", "Nein")}><i className="fa-solid fa-fw fa-trash"></i></Button>
                    </OverlayTrigger>
                );

                return (
                    <div className="table-options text-end">
                        <OverlayTrigger overlay={<Tooltip>Bearbeiten</Tooltip>}>
                            <Button variant="primary" size="sm" className="me-1" onClick={() => { selectTimeslot(info.row.original); }}><i className="fa-solid fa-fw fa-pen"></i></Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Neuer Termin mit selben Daten</Tooltip>}>
                            <Button href={"/School/CreateTimeslot" + getAddTimeslotUrl(info.row.original)} variant="secondary" size="sm" className="me-1"><i className="fa-solid fa-fw fa-copy"></i></Button>
                        </OverlayTrigger>
                        {delBtn}
                    </div>
                )
            },
            enableSorting: false,
            enableColumnFilter: false,
        }),
    ]

    const reactTable = useReactTable({
        data: timeslots || [],
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    })

    const periodList = [
        { value: 0, label: "alle" },
        { value: 1, label: "aktuelle" },
        { value: 2, label: "vergangene" },
    ];

    const updateTimeslots = (id) => {
        setTimeslots((items) => {
            var newItems = items.filter((timeslot) => {
                if (timeslot.TimeslotID == id) {
                    return false;
                }
                return true;
            });
            return newItems;
        });

        setRealTimeslots((items) => {
            var newItems = items.filter((timeslot) => {
                if (timeslot.TimeslotID == id) {
                    return false;
                }
                return true;
            });
            return newItems;
        });
    };

    const editTimeslot = (timeslot) => {
        setRealTimeslots((timeslots) => {
            return timeslots.map((item) => {
                if (item.TimeslotID == timeslot.TimeslotID) {
                    item.Appointment = timeslot.Appointment;
                    item.StartTime = timeslot.StartTime;
                    item.TimeEnd = timeslot.TimeEnd;
                    item.Grade = timeslot.Grade;
                    item.Class = timeslot.Class;
                    item.Room = timeslot.Room;
                    item.Equipment = timeslot.Equipment;
                    item.Category = timeslot.Category;
                    item.ExpireTime = timeslot.ExpireTime;
                    item.ContactPersonSchool = timeslot.ContactPersonSchool;
                    item.ContactSchool = timeslot.ContactSchool;
                    item.CriminalRecord = timeslot.CriminalRecord;
                }

                return item;
            })
        });
    };

    const filterSlots = (realSlots) => {
        const today = new Date();
        let slots = [];
        if (periodFilter.value == 0) {
            slots = realSlots;
        }
        else if (periodFilter.value == 1) {
            slots = realSlots.filter(i => new Date(i.Appointment) >= today);
        }
        else if (periodFilter.value == 2) {
            slots = realSlots.filter(i => new Date(i.Appointment) <= today);
        }

        if (statusFilter.value != 0) {
            slots = slots.filter(i => i.Status == statusFilter.value);
        }

        
    } 

    const getTimeslots = async () => {
        try {
            let result = await request("/School/GetTimeslots");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut");
                }

                setTimeslots([]);
                setRealTimeslots([]);
            }
            else {
                setRealTimeslots(json.timeslots);

                setYears(json.years.map(item => {
                    return { label: item, value: item };
                }));

                if (json.timeslots.length == 0) {
                    toast.info("Es wurden keinen aktuellen Termine gefunden.");
                }
            }
        }
        catch {
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    };


    const getTimeslotsPast = async () => {
        try {
            setRealTimeslotsPast(false);
            let result = await request("/School/GetTimeslots", { past: true, year: year.value });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }

                return setRealTimeslotsPast([]);
            }

            setRealTimeslotsPast(json.timeslots);
        }
        catch {
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    };

    useEffect(() => {
        getTimeslots();
    }, []);

    useEffect(() => {
        if (!realTimeslots) return;

        const slots = realTimeslots.map(m => {
            const newItem = { ...m };

            newItem.Appointment = formatDate(newItem.Appointment);

            if (newItem.BookedOrganisation) {
                newItem.BookedBusiness = newItem.BookedOrganisation.OrganisationName + " " + newItem.BookedOrganisation.Street + " " + newItem.BookedOrganisation.HouseNo + " " + newItem.BookedOrganisation.PostCode + " " + newItem.BookedOrganisation.City + " ";
                newItem.BookedBusiness += getSalutation(newItem.ContactOrganisation.SalutationID) + " " + newItem.ContactOrganisation.Title + " " + newItem.ContactOrganisation.FirstName + " " + newItem.ContactOrganisation.LastName + " " + newItem.ContactOrganisation.Email;
            }
            else {
                newItem.BookedBusiness = "";
            }

            newItem.Equipment = newItem.Equipment.map((item) => { return item.Description; }).join("; ")

            return newItem;
        });
        setTimeslots(slots);
    }, [realTimeslots]);

    useEffect(() => {
        if (!realTimeslotsPast) {
            return setTimeslotsPast(false);
        }

        const slots = realTimeslotsPast.map(m => {
            const newItem = { ...m };

            newItem.Appointment = formatDate(newItem.Appointment);

            if (newItem.BookedOrganisation) {
                newItem.BookedBusiness = newItem.BookedOrganisation.OrganisationName + " " + newItem.BookedOrganisation.Street + " " + newItem.BookedOrganisation.HouseNo + " " + newItem.BookedOrganisation.PostCode + " " + newItem.BookedOrganisation.City + " ";
                newItem.BookedBusiness += getSalutation(newItem.ContactOrganisation.SalutationID) + " " + newItem.ContactOrganisation.Title + " " + newItem.ContactOrganisation.FirstName + " " + newItem.ContactOrganisation.LastName + " " + newItem.ContactOrganisation.Email;
            }
            else {
                newItem.BookedBusiness = "";
            }

            newItem.Equipment = newItem.Equipment.map((item) => { return item.Description; }).join("; ")

            return newItem;
        });
        setTimeslotsPast(slots);
    }, [realTimeslotsPast]);

    useEffect(() => {
        getTimeslotsPast();
    }, [year])

    if (!timeslots) return <Loader />


    return (
        <>
            <Tabs
                id="contingent-tab"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
            >
                <Tab key="now" eventKey="now" title="Aktuell">
                    <Table striped responsive="xl">
                        <thead>
                            {reactTable.getHeaderGroups().map(headerGroup => (
                                <TableHeader key={headerGroup.id} table={reactTable} headerGroup={headerGroup} flexRender={flexRender} />
                            ))}
                        </thead>
                        <tbody>
                            {reactTable.getRowModel().rows.map(row => (
                                <tr key={row.id}>
                                    {row.getVisibleCells().map(cell => {
                                        return (
                                            <td key={cell.id}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        )
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Tab>
                <Tab key="past" eventKey="past" title="Vergangenheit">
                    <div className="mb-2 d-flex align-items-center" style={{ width: "320px" }}>
                        <label className="mr-2">Jahr</label>
                        <Select menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            menuPosition={"fixed"} name="filterStatus" options={years} value={year} className="basic-multi-select" placeholder="Bitte auswählen" onChange={(values) => { setYear(values) }} />

                    </div>
                    <TimeslotsPast timeslots={timeslotsPast} getBusinessContact={getBusinessContact} />
                </Tab>
            </Tabs>  

            <EditTimeslot timeslot={timeslot} open={open} setOpen={setOpen} editTimeslot={editTimeslot} />
        </>
    );
}



const TimeslotsPast = ({ timeslots, getBusinessContact }) => {
    const { getSalutation } = useContext(AppContext);
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);

    const columns = [
        columnHelper.accessor('Appointment', {
            header: () => <span>Datum</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeStart', {
            header: () => <span>Startzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeEnd', {
            header: () => <span>Endzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Grade', {
            header: () => <span>Stufe</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Class', {
            header: () => <span>Klasse</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Room', {
            header: () => <span>Raum</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Equipment', {
            header: () => <span>Ausstattung</span>,
            cell: info => info.getValue(),
            enableSorting: false,
            enableColumnFilter: true,
        }),
        columnHelper.accessor('BookedBusiness', {
            header: () => <span>Buchende Organisation</span>,
            cell: info => {
                return getBusinessContact(info.row.original.BookedOrganisation, info.row.original.ContactOrganisation, info.row.original.SndContactOrganisation);
            },
            enableSorting: false,
            enableColumnFilter: true,
        }),
    ]

    const t = useReactTable({
        data: timeslots || [],
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    if (timeslots === false) return <Loader />

    return (
        <Table striped responsive="xl">
            <thead>
                {t.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map(header => {
                            return (
                                <th key={header.id} style={{ whiteSpace: "nowrap" }}>
                                    {header.isPlaceholder
                                        ? null
                                        : (
                                            <>
                                                <div {...{
                                                    className: header.column.getCanSort()
                                                        ? 'cursor-pointer select-none'
                                                        : '',
                                                    onClick: header.column.getToggleSortingHandler(),
                                                }}>
                                                    {flexRender(
                                                        header.column.columnDef.header,
                                                        header.getContext()
                                                    )}
                                                    {{
                                                        asc: <i className="fa-solid fa-sort-up ms-2"></i>,
                                                        desc: <i className="fa-solid fa-sort-down ms-2"></i>,
                                                    }[header.column.getIsSorted()] ?? (header.column.getCanSort() ? <i className="fa-solid fa-sort ms-2"></i> : null)}
                                                </div>
                                                {header.column.getCanFilter() ? (
                                                    <div>
                                                        <CustomFilter column={header.column} table={t} />
                                                    </div>
                                                ) : null}
                                            </>
                                        )
                                    }
                                </th>
                            )
                        })}
                    </tr>
                ))}
            </thead>
            <tbody>
                {t.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => {
                            return (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            )
                        })}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}


export default Timeslots;